import { useState, useEffect } from 'react';

export default function useMaskyoo() {

    const [phoneNumber, setPhoneNumber] = useState(null);

    useEffect(() => {
         window._msq =  window._msq || [];

         window._msq['SendCallerIDToGoogleAnalytics'] = false;
        //  window._msq['msq_url']='https://8yjpzxkf8a.execute-api.eu-west-1.amazonaws.com/dynamic_numbers_cellcom/public/';

         window._msq['msq_url'] = 'https://api.dynamic-number.com/stage37/public/';
         window._msq['platform'] = 'cellcom';
         window._msq['Debug'] = false;
         window._msq['die_timeout'] = (10 * 60 * 1000); // will return to the original number after 10min
         window._msq['qp'] = new URLSearchParams(window.location.search);

         window._msq['custom_client_var'] = new Object();
         window._msq['custom_client_var'].callback_url = "";                                   	// call back url
         window._msq['custom_client_var'].gclid =  window._msq['qp'].get('gclid') || "";             	// gclid
         window._msq['custom_client_var'].utm_term =  window._msq['qp'].get('utm_term') || "";        	// utm_term 
         window._msq['custom_client_var'].utm_medium =  window._msq['qp'].get('utm_medium') || "";     	// utm_medium          
         window._msq['custom_client_var'].utm_campaign =  window._msq['qp'].get('utm_campaign') || "";  // utm_campaign
         window._msq['custom_client_var'].utm_content =  window._msq['qp'].get('utm_content') || "";	// utm_content 
         window._msq['custom_client_var'].utm_source =  window._msq['qp'].get('utm_source') || "";      // utm_source
         window._msq['custom_client_var'].label =  window._msq['qp'].get('label') || "";            	// label   
         window._msq['custom_client_var'].device =  window._msq['qp'].get('device') || "";          	// device  
         window._msq['custom_client_var'].medium =  window._msq['qp'].get('medium') || "";          	// medium  
         window._msq['custom_client_var'].ref = document.location.href;            				// ref  
         window._msq['custom_client_var'].bid =  window._msq['qp'].get('bid') || "";                	// bid  
         window._msq['custom_client_var'].keyword =  window._msq['qp'].get('keyword') || "";        	// keyword  
         window._msq['custom_client_var'].matchtype =  window._msq['qp'].get('matchtype') || "";    	// matchtype  
         window._msq['custom_client_var'].adgroupID =  window._msq['qp'].get('adgroupID') || "";    	// adgroupID   
         window._msq['custom_client_var'].campaignID =  window._msq['qp'].get('campaignId') || "";      // campaignNameC  
         window._msq['custom_client_var'].page_title = document.title || "";                 	// title
         window._msq['custom_client_var'].load_time = new Date().toString() || "";            	// Page load time
         window._msq['custom_client_var'].landingPage = document.location.href;					// Page URL
         window._msq['custom_client_var'].current_page = document.location.href;				// Page URL
         window._msq['custom_client_var'].real_current_page = document.location.href;			// Page URL
         window._msq['custom_client_var'].pltID =  window._msq['qp'].get('pltID') || ""; 				// SourceOther

        (function () {
            var msq_src = document.createElement('script');
            msq_src.type = 'text/javascript';
            msq_src.async = false;
            msq_src.src = 'https://s3.eu-central-1.amazonaws.com/maskyoo-cdn/class.maskyoov8.js';
            var msq_s = document.getElementsByTagName('script')[0];

            msq_s.parentNode.insertBefore(msq_src, msq_s);
            var msq_r = function (f) {
                if (/loaded|complete/.test(document.readyState)) f();
                else setTimeout(function () { msq_r(f); }, 9);
            }

            // Need to wait for maskyoo API function to be available.
            msq_r(function () {
                var dynamicNumber = window.maskyoo( window._msq, { 'msq_api_key': 'b537e9d0-f756-11ea-8fdc-4dd8905a2c19', 'ReplacePhoneByClass': 'cellcom_dynamic', 'static_phone': '052-9996750' });
                var timer = setInterval(function() {
                    if (dynamicNumber.maskyoophone) {
                        setPhoneNumber(dynamicNumber.maskyoophone);
                        clearInterval(timer);
                    }
                }, 500);
            });
        })();

        
    }, []);

    return phoneNumber;
}
